import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  ScrollRestoration,
} from "react-router-dom";
import './App.css';
// https://clinic.salamatpayanew.ir
import { Login } from "./student/Login";
import { Register } from "./student/Register";
import { PanelStudent } from "./student/PanelStudent";
import { Info } from "./student/Info";
import { Consultant } from "./student/Consultant";
import { ListHealt } from "./student/ListHealt";
import { NobatOnlineAssistant } from "./student/NobatOnlineAssistant";
import { FolderOldp } from "./student/FolderOldp";

import { DasheboardCard } from "./student/DasheboardCard";
import { Ticket } from "./student/Ticket";
import { SicknessPeriod } from "./student/SicknessPeriod";
import { Memoir } from "./student/Memoir";
import { SummeryDoc } from "./student/SummeryDoc";
import { Cardex } from "./student/Cardex";
import { MedicalCommand } from "./student/MedicalCommand";
import { GetNumber } from "./student/GetNumber";
import { Profile } from "./student/Profile";
import { Dashboard } from './admin/Dashboard'
import { AdminLogin } from './admin/AdminLogin'
import { Pregnancy } from './admin/Pregnancy'

import { UsersList } from './admin/UsersList'
import { AdminConsultant } from './admin/AdminConsultant'
import { AdminPanel } from './admin/AdminPanel'
import { Diagnosis } from './admin/Diagnosis'
import { ReportAll } from './admin/ReportAll'

import { LoginConsultant } from './consultant/LoginConsultant'
import { PanelConsultant } from './consultant/PanelConsultant'
import { StudentList } from './consultant/StudentList'
import { DasheboardCons } from './consultant/DasheboardCons'

import { MedicalCommandAdmin } from './admin/MedicalCommandAdmin'
import { CardexAdmin } from './admin/CardexAdmin'
import { SummeryDocAdmin } from './admin/SummeryDocAdmin'
import { MemoirAdmin } from './admin/MemoirAdmin'
import { SicknessPeriodAdmin } from './admin/SicknessPeriodAdmin'

import { FolderUserProfile } from './admin/FolderUserProfile'
import { Services } from './admin/Services'
import { AccountReport } from './admin/AccountReport'
import { OnlineAccount } from './admin/OnlineAccount'
import { OldFolder } from './admin/OldFolder'
import {Header} from './layout/Header'
import {Footer} from './layout/Footer'
import {Home} from './layout/Home'
import {NobatOnline} from './layout/NobatOnline'

const  App = () => {

  const HomeExt = () =>{
      return(
        <div>
          <Header />
          <Home />
          <Footer />
        </div>
      )
  }
  const HomeExtRn = () =>{
    return(
      <div>
        <Header />
        <NobatOnline />
        <Footer />
      </div>
    )
}
  const LyoutLoing = () => {
    return (
      <div>
        <Login />
        <Outlet />
      </div>
    );
  };

  const StudentRegister = () => {
    return (
      <div>
        <Register />
        <Outlet />
      </div>
    );
  };

  const GetPhoneNumber = () => {
    return (
      <div>
        <GetNumber />
        <Outlet />
      </div>
    );
  };

  const PanelStudentChk = () => {
    return (
      <div>
        <PanelStudent />
        <Outlet />
      </div>
    );
  };

  const AdminLogins = () => {
    return (
      <div>
        <AdminLogin />
        <Outlet />
      </div>
    );
  };

  const PanelAdminSec = () => {
    return (
      <div>
        <Dashboard />
        <Outlet />
      </div>
    );
  };


  const SecurityConultant = () => {
    return (
      <div>
        <LoginConsultant />
        <Outlet />
      </div>
    );
  };

  const PanelConsultantRol = () => {
    return (
      <div>
        <PanelConsultant />
        <Outlet />
      </div>
    );
  };

  const router = createBrowserRouter([
    {
      path:'/',
      element:<HomeExt />
    },
    {
      path:'/OnlineNobat',
      element:<HomeExtRn />
    },
    

    // Admin Consultatnt
    {
      path: "/Login",
      element: <SecurityConultant />,
    },
    

    {
      path: "/PanelConsultantRps",
      element: <PanelConsultantRol />,
      children: [
        
        {
          path: "/PanelConsultantRps/DasheboardCons",
          element: <DasheboardCons />,
        },
        {
          path: "/PanelConsultantRps/StudentList",
          element: <StudentList />,
        },

      ],
    },

    // AdminPanel
    
    {
      path: "/AdminLogin",
      element: <AdminLogins />,
    },
   
    {
      path: "/AdminPanel",
      element: <PanelAdminSec />,
      children: [
        {
          path: "/AdminPanel/ViewPanel",
          element: <AdminPanel />,
        },
        {
          path: "/AdminPanel/UsersList",
          element: <UsersList />,
        },
        {
          path: "/AdminPanel/AdminConsultant",
          element: <AdminConsultant />,
        },     
        
        {
          path: "/AdminPanel/MedicalComman",
          element: <MedicalCommandAdmin />,
        },   
        {
          path: "/AdminPanel/folderCardex",
          element: <FolderUserProfile />,
        },   
        {
          path: "/AdminPanel/serviceCardex",
          element: <Services />,
        },
        {
          path: "/AdminPanel/AccountReport",
          element: <AccountReport />,
        },
        {
            path: "/AdminPanel/accountOnline",
            element: <OnlineAccount />,
         },
       
        {
          path: "/AdminPanel/Cardex",
          element: <CardexAdmin />,
        },   
        {
          path: "/AdminPanel/SummeryDoc",
          element: <SummeryDocAdmin />,
        },   
        {
          path: "/AdminPanel/Memoir",
          element: <MemoirAdmin />,
        },   
        {
          path: "/AdminPanel/SicknessPeriod",
          element: <SicknessPeriodAdmin />,
        },
        {
          path: "/AdminPanel/PregnancyForm",
          element: <Pregnancy />,
        },
        {
          path: "/AdminPanel/diagnos",
          element: <Diagnosis />,
        },
        {
          path: "/AdminPanel/allreport",
          element: <ReportAll />,
        },
        {
          path: "/AdminPanel/folder",
          element: <OldFolder />,
        },
        
      ],
    },

// Student Panel
    {
      path: "/loginuser",
      element: <LyoutLoing />,
    },
    {
      path: "/register",
      element: <StudentRegister />,
      
    },
    {
      path: "/getNumber",
      element: <GetPhoneNumber />,
      
    },
    
    {
      path: "/AssistantAdmin",
      element: <PanelStudentChk />,
      children: [
        {
          path: "/AssistantAdmin/Info",
          element: <Info />,
        },
        {
          path: "/AssistantAdmin/Consultant",
          element: <Consultant />,
        },
        {
          path: "/AssistantAdmin/DasheboardCard",
          element: <DasheboardCard />,
        },
        {
          path: "/AssistantAdmin/Ticket",
          element: <Ticket />,
        },
        {
          path: "/AssistantAdmin/SicknessPeriod",
          element: <SicknessPeriod />,
        },
        {
          path: "/AssistantAdmin/Memoir",
          element: <Memoir />,
        },
        {
          path: "/AssistantAdmin/SummeryDoc",
          element: <SummeryDoc />,
        },
        {
          path: "/AssistantAdmin/Cardex",
          element: <Cardex />,
        },
        {
          path: "/AssistantAdmin/MedicalCommand",
          element: <MedicalCommand />,
        },
        {
          path: "/AssistantAdmin/Profile",
          element: <Profile />,
        },
        {
          path: "/AssistantAdmin/onlinelist",
          element: <ListHealt />,
        },
        {
          path: "/AssistantAdmin/onlineNobatAdd",
          element: <NobatOnlineAssistant />,
        },
        {
          path: "/AssistantAdmin/folderold",
          element: <FolderOldp />,
        },
        
        
      ],
    },

  ]);

  return (
    <>
     <div className="app">
      <RouterProvider router={router} />
    </div>
    </>
  );
}

export default App;
